@if(field){
<div class="date-container" [formGroup]="form">
  <mat-form-field class="dynamic-mat-form-field" appearance="outline">
      <mat-label>{{field['displayName']|camelCase}}</mat-label>
      <input [id]="field['fieldName']" matInput  [matDatepicker]="picker" [value]="inputData" [formControlName]="field['fieldName']" [attr.required]="field.required ? true : null"
      [min]="field.min" [max]="field.max" (dateChange)="onDateChange(field.fieldName, $event.value)">
      <span matSuffix class="date-actions">
        <mat-icon class="clearData" *ngIf="inputData" (click)="clearDate()" (keydown.enter)="clearDate()" tabindex="0">cancel</mat-icon>
        <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
      </span>
  <mat-datepicker #picker [startView]="field.monthYearOnly ? 'multi-year' : 'month'" [disabled]="field.disabled"
    (monthSelected)="field.monthYearOnly && onMonthSelected(field.fieldName, $event, picker)"></mat-datepicker>
  @if(form.get(field['fieldName'])?.hasError('required')&& form.get(field['fieldName'])?.touched){
      <mat-error> {{field.displayName | camelCase}} is required</mat-error>
      }
  </mat-form-field>
  <div class="border"></div>
</div>
}